/**
 * @fileoverview Route configuration for dashboard feature.
 */

import { lazy } from 'react';
import { createRoutes } from '../utils/routeHelpers';

const DashboardPage = lazy(() => import('../../features/dashboard/pages/DashboardPage'));

export const dashboardRoutes = createRoutes([
  { path: '', Component: DashboardPage },
]);
